// PIXI production bundle
// https://pixijs.io/customize/
// https://medium.com/anvoevodin/how-to-set-up-pixijs-v5-project-with-npm-and-webpack-41c18942c88d
// prod: npm install @pixi/app @pixi/constants @pixi/core @pixi/display @pixi/graphics @pixi/math @pixi/runner @pixi/settings @pixi/sprite @pixi/text @pixi/ticker @pixi/utils
// dev: npm install pixi.js --save-dev
// dev environment uses full PIXI install to benefit from type hinting.

export * from '@pixi/constants';
export * from '@pixi/math';
export * from '@pixi/runner';
export * from '@pixi/settings';
export * from '@pixi/ticker';
import * as utils from '@pixi/utils';
export { utils };
export * from '@pixi/display';
export * from '@pixi/core';
export * from '@pixi/sprite';
export * from '@pixi/app';
export * from '@pixi/graphics';
export * from '@pixi/text';

// Renderer plugins
import { Renderer } from '@pixi/core';
import { BatchRenderer } from '@pixi/core';
Renderer.registerPlugin('batch', BatchRenderer);

// Application plugins
import { Application } from '@pixi/app';
import { TickerPlugin } from '@pixi/ticker';
Application.registerPlugin(TickerPlugin);
